// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--CaNgt";
export var container = "footer-module--container--CUQfB";
export var row = "footer-module--row--AKys1";
export var logo = "footer-module--logo--gs3eT";
export var nav = "footer-module--nav--7v9wR";
export var smallText = "footer-module--smallText--C1siq";